export const institutos = {
    'undefined': '',
    '0': 'Itbm',
    '1': 'Mexico ',
    '2': 'Midden-Amerika en het Caribisch gebied',
    '3': 'Midden-Amerika en het Caribisch gebied',
    '4': 'Singapore',
    '5': 'Turkije',
    '6': 'Filippijnen',
    '7': 'Ecuador',
    '8': 'izzi',
    '9': 'Romania',
    '11': 'Brazil',
    '12': 'Chile',
    '13': 'Argentinië',
    '14': 'Broker 14',
    '15': 'Spanje',
    '16': 'Itbm',
    '17': 'Een onderzoek',
  }


  export const sectores = {
    "1":{
       "NOMBRE":"2.0 Ruimtevaart",
       "SUBSECTORES":{
          "1":"2.1 Lucht- en ruimtevaart // Overig / Niet van toepassing"
       }
    },
    "2":{
       "NOMBRE":"4.0 Landbouw",
       "SUBSECTORES":{
          "1":"4.1 Landbouw // Overig / Niet van toepassing "
       }
    },
    "3":{
       "NOMBRE":"5.0 Biotechnologie en farmaceutische producten",
       "SUBSECTORES":{
          "1":"5.1 Biotechnologie en farmaceutica // Biotechnologie",
          "2":"5.2 Biotechnologie en farmaceutica // Farmaceutisch",
          "3":"5.3 Biotechnologie en farmaceutica // Overig"
       }
    },
    "4":{
       "NOMBRE":"6.0 Constructie",
       "SUBSECTORES":{
          "1":"(OUD) Bouw // Contracting",
          "2":"(OUDE) Bouw // Infra",
          "3":"6.1 Constructie // Overig / Niet van toepassing"
       }
    },
    "5":{
       "NOMBRE":"12.0 Gezondheidszorg",
       "SUBSECTORES":{
          "1":"(OUDE) Gezondheidszorg // Woonzorgdiensten",
          "2":"12.1 Gezondheidszorg // Ziekenhuis",
          "3":"12.2 Gezondheidszorg // Verkoop of distributie van medische benodigdheden",
          "4":"12.3 Gezondheidszorg // Specialiteit",
          "5":"(OUD) Ouderendiensten // Thuiszorg",
          "6":"(OUD) Ouderendiensten // Huisvesting en zorg voor ouderen care",
          "7":"(OUD) Medische zorg // Overige gespecialiseerde diensten",
          "8":"12.4 Gezondheidszorg // Diensten",
          "9":"12.5 Gezondheidszorg // Overig",
       }
    },
    "6":{
       "NOMBRE":"7.0 Onderwijs en opleiding",
       "SUBSECTORES":{
          "1":"7.1 Onderwijs en training // Overig / Niet van toepassing"
       }
    },
    "7":{
       "NOMBRE":"13.0 Gastvrijheid",
       "SUBSECTORES":{
          "3":"13.1 Gastvrijheid // Eten en drinken",
          "2":"13.2 Gastvrijheid // Hotel / Resort",
          "1":"13.3 Gastvrijheid // Administratie",
          "4":"13.4 Gastvrijheid // Overig"
       }
    },
    "8":{
       "NOMBRE":"16.0 Productie en productie",
       "SUBSECTORES":{
          "28":"16.1 Fabricage en productie // Alternatieve energie",
          "1":"16.2 Productie en productie // Automotive",
          "15":"16.3 Fabricage en productie // Basismetalen en metaalproducten",
          "14":"16.4 Fabricage en productie // Constructiematerialen",
          "24":"16.5 Productie en productie // Chemicaliën",
          "3":"16.6 Fabricage en productie // Cokes, petroleumderivaten en nucleaire brandstof",
          "8":"16.7 Fabricage en productie // Elektrische, elektronische en optische apparatuur",
          "6":"16.8 Productie en productie // Elektronica",
          "7":"16.9 Fabricage en productie // Energie",
          "5":"16.10 Fabricage en productie // Energiedistributie",
          "20":"16.11 Fabricage en productie // Voedingsproducten: zuivel- en pluimveeproducten",
          "21":"16.12 Fabricage en productie // Voedingsmiddelen: tabak To",
          "19":"16.13 Productie en productie // Voedingsmiddelen: dranken",
          "18":"16.14 Productie en productie // Voedingsproducten: Overige",
          "16":"16.15 Fabricage en productie // Meubilair",
          "10":"16.16 Productie en productie // Benzine / Detailhandel",
          "31":"16.17 Productie en productie // Gezondheidszorg",
          "17":"16.18 Fabricage en productie // Leer en leerproducten",
          "13":"16.19 Fabricage en productie // Machines en uitrusting",
          "11":"16.20 Productie en productie // Medische hulpmiddelen",
          "22":"16.21 Productie en productie // Niet-metaalhoudende mineralen",
          "2":"16.22 Fabricage en productie // Producten voor persoonlijke verzorging en thuiszorg",
          "23":"16.23 Fabricage en productie // Pulp, papier en papierderivaten",
          "4":"16.24 Fabricage en productie // Rubber- en kunststofproducten",
          "25":"16.25 Fabricage en productie // Veiligheid",
          "26":"16.26 Fabricage en productie // Textiel en textielproducten",
          "30":"16.27 Fabricage en productie // Transportmiddelen",
          "29":"16.28 Fabricage en productie // Watervoorziening en -behandeling",
          "12":"16.29 Fabricage en productie // Hout en houtderivaten",
          "32":"16.30 Productie en productie // Overig",
          "27":"(OUD) Productie en productie // Fast-moving consumer goods",
          "9":"(OUDE) Productie en productie // Gezondheidszorg",
       }
    },
    "9":{
       "NOMBRE":"17.0 Media",
       "SUBSECTORES":{
          "1":"17.1 Media // Uitgevers en drukkers",
          "4":"17.2 Media // Televisie / Film / Video",
          "2":"17.3 Media // Radio",
          "3":"17.4 Media // Internetdiensten",
          "5":"17.5 Media // Overig",
       }
    },
    "10":{
       "NOMBRE":"18.0 Mijnbouw en steengroeven",
       "SUBSECTORES":{
          "1":"18.1 Mijnen en steengroeven // Overig / Niet van toepassing"
       }
    },
    "11":{
       "NOMBRE":"(OUD) Non-profit en liefdadigheidsorganisaties",
       "SUBSECTORES":{
          "1":"-"
       }
    },
    "12":{
       "NOMBRE":"21.0 Detailhandel",
       "SUBSECTORES":{
          "4":"21.1 Detailhandel // Kleding / Textiel / Schoeisel",
          "2":"21.2 Detailhandel // Computers / Elektronica",
          "1":"21.3 Detailhandel // Voeding / Magazijn",
          "5":"21.4 Detailhandel // Elektronische handel",
          "3":"21.5 Detailhandel // Speciale producten",
          "6":"21.6 Detailhandel // Overige",
       }
    },
    "13":{
       "NOMBRE":"11.0 Financiële diensten en verzekeringen",
       "SUBSECTORES":{
          "1":"11.1 Financiële diensten en verzekeringen // Investeringen",
          "9":"11.2 Financiële diensten en verzekeringen // Boekhouding",
          "8":"11.3 Financiële en verzekeringsdiensten // Bank- / Kredietdiensten",
          "5":"11.4 Financiële diensten en verzekeringen // Ziektekostenverzekering",
          "7":"11.5 Financiële diensten en verzekeringen // Verzekeringen in het algemeen",
          "6":"11.6 Financiële diensten en verzekeringen // Levensverzekering",
          "3":"11.7 Financiële diensten en verzekeringen // Autoverzekering",
          "4":"11.8 Financiële diensten en verzekeringen // Woningverzekering",
          "2":"11.9 Financiële diensten en verzekeringen // Herverzekering",
          "10":"11.10 Financiële diensten en verzekeringen // Overige",
       }
    },
    "14":{
      "NOMBRE":"14.0 Industriële diensten",
      "SUBSECTORES":{
        "3":"14.1 Industriële diensten // Reparatie en onderhoud van voertuigen",
        "2":"14.2 Industriële diensten // Industrieel ontwerp",
        "1":"14.3 Industriële diensten // Afval / Afval / Recyclingbeheer",
        "4":"14.4 Industriële diensten // Overig",
      }
    },
    "15":{
       "NOMBRE":"19.0 Professionele diensten",
       "SUBSECTORES":{
          "14":"19.1 Professionele diensten // Reclame en marketing",
          "2":"19.2 Professionele diensten // Architectuur / Design",
          "5":"19.3 Professionele diensten // Advies - Administratie",
          "7":"19.4 Professionele diensten // Technisch advies",
          "4":"19.5 Professionele diensten // Milieuadvies",
          "8":"19.6 Professionele diensten // Productieadvies",
          "3":"19.7 Professionele dienstverlening // Risicobeoordeling / Actuarieel advies",
          "11":"19.8 Professionele diensten // Juridisch advies",
          "16":"19.9 Professionele diensten // Beveiliging",
          "15":"19.10 Professionele diensten // Inhuren van personeel",
          "6":"19.11 Professionele services // Telefonische ondersteuning / Verkoopcentra",
          "1":"19.12 Professionele diensten // Reisadministratie",
          "19":"19.13 Professionele diensten // Overige",
          "12":"(OUD) Professionele diensten // Uitbesteding van bedrijfsprocessen",
          "13":"(OUD) Professionele diensten // Uitbesteding van bedrijfsprocessen / Callcenters",
          "9":"(OUD) Professionele diensten // Boekhouding, boekhouding en auditing",
          "17":"(OUD) Professionele diensten // Reclame en marketing / Reclame",
          "18":"(OUD) Professionele diensten // Reclame en marketing / Direct marketing",
          "10":"(OUD) Professionele dienstverlening // Onderwijs en opleiding"
       }
    },
    "16":{
       "NOMBRE":"22.0 Sociale diensten en overheidsinstanties",
       "SUBSECTORES":{
          "3":"22.1 Sociale diensten en overheidsinstanties // Zakelijke diensten",
          "1":"22.2 Sociale diensten en overheidsinstanties // Cultuur en kunst",
          "2":"22.3 Sociale diensten en overheidsinstanties // Onderwijs",
          "6":"22.4 Sociale diensten en overheidsinstanties... Activiteiten in het algemeen openbaar bestuur",
          "5":"22.5 Sociale diensten en overheidsinstanties // Huisvesting",
          "4":"22.6 Sociale diensten en overheidsinstanties // Menselijke gezondheid en maatschappelijk werk",
          "7":"22.7 Sociale diensten en overheidsinstanties // Woonzorg",
          "8":"22.8 Sociale diensten en overheidsinstanties // Overig",
       }
    },
    "17":{
       "NOMBRE":"15.0 Informatietechnologie",
       "SUBSECTORES":{
          "3":"15.1 Informatietechnologie // Hardware",
          "4":"15.2 Informatietechnologie // Internetserviceprovider",
          "5":"15.3 Informatietechnologie // Software",
          "6":"15.4 Informatietechnologieën // Internetdiensten",
          "1":"15.5 Informatietechnologie // IT-advies",
          "2":"15.6 Informatietechnologie // Gegevensopslag / Beheer",
          "7":"15.7 Informatietechnologie // Overig",
       }
    },
    "18":{
       "NOMBRE":"24.0 Vervoer",
       "SUBSECTORES":{
          "2":"24.1 Transport // Luchtvaartmaatschappij / Commerciële luchtvaart",
          "1":"24.2 Transport // Pakketvervoer",
          "3":"24.3 Vervoer // Vervoer over land en over zee van passagiers",
          "4":"24.4 Transport // Transport en opslag",
          "5":"24.5 Transport // Overig",
       }
    },
    "19":{
       "NOMBRE":"23.0 Telecommunicatie",
       "SUBSECTORES":{
          "1":"23.1 Telecommunicatie // Anders / Niet van toepassing"
       }
    },
    "20":{
       "NOMBRE":"8.0 Elektronica",
       "SUBSECTORES":{
          "1":"8.1 Elektronica // Overig / Niet van toepassing"
       }
    },
    "21":{
       "NOMBRE":"9.0 Techniek",
       "SUBSECTORES":{
          "1":"9.1 Engineering // Anders / Niet van toepassing"
       }
    },
    "22":{
       "NOMBRE":"10.0 Amusement",
       "SUBSECTORES":{
          "3":"10.1 Entertainment // Podiumkunsten en kijksporten",
          "2":"10.2 Amusement // Musea",
          "1":"10.3 Entertainment // Plezier en kansspelen",
          "4":"10.4 Entertainment // Overig",
       }
    },
    "23":{
       "NOMBRE":"20.0 Vastgoed",
       "SUBSECTORES":{
          "1":"20.1 Vastgoed // Huisvesting",
          "2":"20.2 Vastgoed // Vastgoedbeheer",
          "3":"20.3 Vastgoed // Overig",
       }
    },
    "24":{
       "NOMBRE":"25.0 Andere",
       "SUBSECTORES":{
          "1":"25.1 Anders / Niet van toepassing"
       }
    },
    "25": {
      "NOMBRE":"3.0 Diensten voor ouderen",
      "SUBSECTORES": {
        "1":"3.1 Diensten voor ouderen // Huisvesting en zorg voor ouderen",
        "2":"3.2 Diensten voor ouderen // Thuiszorg",
        "3":"3.3 Diensten voor ouderen // Overig",
      }
    }
  }

  export const ranking = {
    '1': {
      'NOMBRE': 'Yes',
      'TIPO': {
        '1': 'Minder dan 50',
        '2': '50 tot 500 Geen multinationals',
        '3': '50 tot 500 multinationals',
        '4': 'Groot (500 tot 4999) ',
        '5': '5000 of meer'
        // '6': 'Public Sector',
        // '7': 'Does not participate in the Ranking'
      }
    },
    '2': {
      'NOMBRE': 'No',
      'TIPO': {
        '1': 'Minder dan 50',
        '2': '50 tot 500 Geen multinationals',
        '3': '50 tot 500 multinationals',
        '4': 'Large (500 to 4999)',
        '5': '5000 of meer'
      }
    },
    'Nacional': 'nationaal',
    'Multinacional': 'multinationale'
  }

  export const productos = {
    '1': 'Certificeren',
    '2': 'Meting',
    '3': 'NOM-035',
    '4': 'Pulscontrole',
    '5': 'Documentator NOM-035',
    '6': 'Focusgebied',
    '7': 'Bestandsbeheer',
    '8': 'Cultuur Audit',
    '9': 'Cultuur Audit 5.0',
    '10': 'Cultuur Audit Opleiding',
    '11': 'Meting enhanced',
    '12': 'Meting + MST',
    '13': 'Meting per gebied',
    '14': 'Meting door leiders',
    '15': 'Meting door afmetingen',
    '16': 'Meting certificeren',
    '17': 'Resultaten',
    '18': '4Alle',
    '19': 'NOM-035 Better',
    '20': 'Certificeren v2.0',
    '21': 'Globale resultaten',
    '22': '4ALL oefent enkelvoudige resultaten',
    '23': 'Volledige resultaten',
    '24': 'ZILVEREN pakket',
    '25': 'GOUD pakket',
    '26': 'PLATINUM-pakket',
    '27': 'Izzi',
    '30': 'Cultuuraudit Costa Rica',
    '31': 'Cultuuraudit GoFlow',
    '32': 'Cultuuraudit 5.0 Panamá',
    '33': 'Cultuur Audit 5.0 Strategische partners',
    '34': 'Resultaten 5.0 Versión 3.1',
    '35': 'Resultaten 5.0 Versión 3.2',
    '36': 'Resultaten 5.0 Versión 3.3',
    '37':'Cultuur Audit SP',
    '38':'Actieplan',
    '39':'NOM-035 Silver',
    '40': 'Certificeren v3.0',
    '41': 'Meting v3.0',
    '42': 'Pulscontrole v3.0',
    '43': 'Focusgebied  v3.0',
    'CULTUREGOEXPRESS':'Cultural Go Express',
    '53':'Leider GO',
    '54':'Action GO',
    '56': 'AMCO',
    '57': 'Fatsoenlijk werk',
    '58':'Eerste baan',
    'ENCUESTA':'Bijkomende certificaties',
    '60':'Certificeren (import emprising)',
    '61':'Cultuur Brief',
    '62':'Cultuur Audit',
    '63': 'NOM-035 v3.0',
    '64':'SP 2022',
    '65':'Cultuur Audit GoFlow 2 2022',
    '66':'Cultuur Audit Standaard 1',
    '67':'Cultuur Audit® CA&C',
    '69': 'Certificeer zilver',
    '70':'GoFlow resultaten',
    '71': 'Cultuur Audit (certificeren) 2022',
    '72': 'Cultuur Audit (certificeren, rkg.) 2022',
    '73': 'Cultuur Audit (certificeren, rkg. en adic.) 2022',
    '68':'Swift',
    '76':'Cultuur Audit (certificeren,rkg. y adic.) 2024',
    '77':'Cultuurnota (certificeren) 2024',
    '78':'Cultuuraudit (certificeren en rangschikken) 2024',

  }

  export const productosTurquia = {
    '1': 'Certificeren',
    '2': 'Meting',
    '3': 'NOM-035',
    '4': 'Pulscontrole',
    '5': 'Documentator NOM-035',
    '6': 'Focusgebied',
    '7': 'Bestandsbeheer',
    '8': 'Cultuur Audit',
    '9': 'Cultuurbrief ve Cultuur Audit 5.0',
    '10': 'Cultuur Audit Opleiding',
    '11': 'Meting verbeterd',
    '12': 'Meting + MST',
    '13': 'Meting per gebied',
    '14': 'Meting door leiders',
    '15': 'Meting op maat',
    '16': 'Meting om te certificeren',
    '17': 'Results',
    '18': '4AllE',
    '19': 'NOM-035 Better',
    '20': 'Certificeren v2.0',
    '21': 'Globale resultaten',
    '22': '4ALL oefent enkele resultaten ',
    '23': 'Volledige resultaten',
    '24': 'ZILVEREN pakket',
    '25': 'GOUD pakket',
    '26': 'PLATINUM-pakket',
    '27': 'Izzi',
    '28': 'Cultuurbrief 5.0',
    '29': 'Cultuur Audit 5.0',
    '30': 'Cultuur Audit Costa Rica',
    '31': 'Cultuur Audit GoFlow',
    '32': 'Cultuur Audit 5.0 Panamá',
    '33': 'Cultuur Audit 5.0 Strategische partners',
    '34': 'Results 5.0 Versión 3.1',
    '35': 'Results 5.0 Versión 3.2',
    '36': 'Results 5.0 Versión 3.3',
    '40': 'Certificeren v3.0',
    '41': 'Meting v3.0',
    '42': 'Pulscontrole v3.0',
    '43': 'Focusgebied  v3.0',
    '60': 'Certificeren (import emprising)',
    '54':'Action GO',
    '74':'Özel Liste',

  }

  export const categorias = {
    'Certify': 'Certificeer producten',
    'Measure': 'Measurement products',
    'Norm 35': 'NOM-035 products',
    'Pulse Check': 'Pulse Check products',
    'Focus Area': 'Focus Area products',
    'Drive': 'File manager',
    'Culture Audit': 'Culture Audit products',
    'Resultados': 'Results\' products',
    'Resultados 4 ALL': '4All products',
    'Resultados 5.0': 'Results 5.0 products',
    'Culture Audit Action Plan':'Action plan',
    'Leader GO':'Leider GO',
    'Action GO':'Action GO',
    'Certify Amco':'Bijkomende certificaties',
    'PRODUCTOS_ICCA':'ICCA products',
    'Resultados V2 HK': 'Certificeren (import emprising)',
    'Swift':'Swift',

  }

  export const niveles = {
    '1': 'Bedrijf',
    '2': 'Beheerder',
    '3': 'ITBM',
    '4': 'Resultaten',
    '5': 'Gesegmenteerde resultaten',
    '8': 'Cultuur Audit-product',
    '9':'Resultaten 5.0',
    '10':'Bedrijf HR',
    '11': 'Izzi',
    '12': 'ActionGo',
    '13': 'Gesegmenteerde resultaten en ActionGo',
    '14': 'ActionGo-leider',
    '15': 'Gebruiker ActieGo Leider',
    '17': 'Swift Wholesaler',
    '18': 'Web bedrijfsprofiel',
    '19': 'Resultaten 2.0',
  }

  export const regiones = {
    '1': 'Caraïben',
    '2': 'Centraal Amerika',
    '3': 'Midden-Amerika en het Caribisch gebied',
    '4': 'Regio Bajio',
    '5': 'Centrale regio',
    '6': 'West Central Region',
    '7': 'Zuid-centrale regio',
    '8': 'Regio noordoost',
    '9': 'Noordwestelijke regio',
    '10': 'Regio Zuidoost',
    '11': 'Groot-China',
    '12': 'Taiwan',
    '13': 'Vasteland van China',
    '14': 'Groot-China',
    '15': 'Turkey',
  }

  export const plantillas = {
    '5d826095d06d596a84de6315': {
      'NOMBRE':'04_ESP_ING_POR_ESTANDAR'
    },

    '5dcb61e940fb582bc44adf49': {
      'NOMBRE':'TR_ESTANDAR'
    },

    '5dcc946633e1ff000870107e': {
      'NOMBRE':'04_ENGLISH_JAPAN'
    },

    '5dcdd9fd33e1ff1aacf6f04f': {
      'NOMBRE':'01_NORM035_ES_EN_-50'
    },

    '5ddc3fa4f323d727d09870ad': {
      'NOMBRE':'ING_SIMP_TRAD_ESTANDAR'
    },

    '5de58de640fb582e0c18d730': {
      'NOMBRE':'04_ESP_ING_POR_ESTANDAR_MEDIR'
    },

    '5de69aa4a943da3efc4d0fa6': {
      'NOMBRE':'04_ESP_ING_POR_ESTANDAR_PULSECHECK'
    },

    '5de9498fa943da3efc4d0fa8': {
      'NOMBRE':'05_ING_ESTANDAR'
    },

    '5df820df65e4986b14d1f71c': {
      'NOMBRE':'01_NORM035_ES_EN_+50'
    },

    '5dfc26cec8800d5188a18875': {
      'NOMBRE':'CAYC_ESTANDAR_ES_Y_EN'
    },

    '5e166105d06d595eb04dca00': {
      'NOMBRE':'Focus_Estandar'
    },

    '5e1754a5f323d72aac6d8726': {
      'NOMBRE':'TR TI + EVP + GPTW LEADER'
    },

    '5e17930b65e4983a3016a4ed': {
      'NOMBRE':'TR TI + EVP'
    },

    '5e2100c6f323d721045812c5': {
      'NOMBRE':'CAYC_ESTANDAR CAYC 2020'
    },

    '5e21042ff323d721045812c6': {
      'NOMBRE':'04_DIVERSIDAD_E_INCLUSIÓN'
    },

    '5e210575f323d721045812c7': {
      'NOMBRE':'04_ESP_GOBIERNO'
    },

    '5e2b6dbdc8800d52f45fc248': {
      'NOMBRE':'TEMPLATE 10 PREGUNTAS ESP'
    },

    '5e2f72c8c8800d3398c463a4': {
      'NOMBRE':'CAYC_GOBIERNO'
    },

    '5e3c59b5b473cb6d3e40f902': {
      'NOMBRE':'ING_RUMANO_ESTANDAR'
    },

    '5e697232b473cb6d3e84d87d': {
      'NOMBRE':'04_ESP_ING_POR_ESTANDAR_MEDIR'
    },

    '5ec8450db473cb6d3ec9d153': {
      'NOMBRE':'04_ESP_ING_ESTANDAR_US_MEDIR1'
    },

    '5ec84527b473cb6d3ec9dcdb': {
      'NOMBRE':'04_ESP_ING_ESTANDAR_MX_MEDIR1'
    },

    '5e6972f3b473cb6d3e84e1e0': {
      'NOMBRE':'04_ESP_ING_POR_ESTANDAR_MEDIR1'
    },

    '5e697302b473cb6d3e84e2a3': {
      'NOMBRE':'04_ESP_ING_POR_ESTANDAR_MEDIR2'
    },

    '5e697311b473cb6d3e84e364': {
      'NOMBRE':'04_ESP_ING_POR_ESTANDAR_MEDIR3'
    },

    '5e697329b473cb6d3e84e490': {
      'NOMBRE':'04_ESP_ING_POR_ESTANDAR_MEDIR4'
    },

    '5f074b90b473cb6d3eb363d1': {
      'NOMBRE':'ESP_MEDIR_CREDIBILIDAD'
    },

    '5e69734fb473cb6d3e84e656': {
      'NOMBRE':'04_ESP_ING_POR_ESTANDAR_MEDIR5'
    },

    '5e697367b473cb6d3e84e791': {
      'NOMBRE':'04_ESP_ING_POR_ESTANDAR_MEDIR6'
    },

    '5e738efbb473cb6d3e8c3915': {
      'NOMBRE':'ESP_CAYC_Diversidad'
    },

    '5e86487eb473cb6d3e09cc42': {
      'NOMBRE':'01_NORM035_ES_EN_-50'
    },

    '5e864896b473cb6d3e09cde1': {
      'NOMBRE':'01_NORM035_ES_EN_+50'
    },
    '5ebb34dab473cb6d3edd2d32': {
      'NOMBRE':'04_ESP_ING_POR_ESTANDAR_US'
    },

    '5ebc06d1b473cb6d3ef68147': {
      'NOMBRE':'04_ESP_ING_POR_ESTANDAR_MX'
    },

    '5f2d7cdfb473cb6d3edd2c48': {
      'NOMBRE':'04_ESP_ING_POR_ESTANDAR_PT'
    },

    //PLANTILLAS DE CERTIFICAR 2.0
      '5e960018b473cb6d3ec5f935': {
        'NOMBRE':'04_ESP_ING_POR_ESTANDAR'
      },

      '5e96007cb473cb6d3ec60098': {
        'NOMBRE':'TR_ESTANDAR'
      },

      '5e9600a6b473cb6d3ec603c7': {
        'NOMBRE':'04_ENGLISH_JAPAN'
      },

      '5e9600f0b473cb6d3ec6095a': {
        'NOMBRE':'ING_SIMP_TRAD_ESTANDAR'
      },

      '5e960116b473cb6d3ec60c2f': {
        'NOMBRE':'05_ING_ESTANDAR'
      },

      '5e96039fb473cb6d3ec64310': {
        'NOMBRE':'CAYC_ESTANDAR_ES_Y_EN'
      },

      '5e9603d7b473cb6d3ec6485e': {
        'NOMBRE':'TR TI + EVP + GPTW LEADER'
      },

      '5e9604f7b473cb6d3ec66540': {
        'NOMBRE':'TR TI + EVP'
      },

      '5e960525b473cb6d3ec66a3f': {
        'NOMBRE':'CAYC_ESTANDAR CAYC 2020'
      },

      '5e960549b473cb6d3ec66e30': {
        'NOMBRE':'04_DIVERSIDAD_E_INCLUSIÓN'
      },

      '5e96056ab473cb6d3ec671f1': {
        'NOMBRE':'04_ESP_GOBIERNO'
      },

      '5e9605b5b473cb6d3ec67a55': {
        'NOMBRE':'CAYC_GOBIERNO'
      },

      '5e9605e0b473cb6d3ec67f3c': {
        'NOMBRE':'ING_RUMANO_ESTANDAR'
      },

      '5e96060fb473cb6d3ec684d8': {
        'NOMBRE':'ESP_CAYC_Diversidad'
      },
      '5edff2d2b473cb6d3e3dcc07': {
        'NOMBRE': 'IZZI_ESTANDAR_ES_Y_EN'
      },

      '5f109a39b473cb6d3ea95e69': {
        'NOMBRE':'ING_VI_ESTANDAR'
      },

      '5f0f390cb473cb6d3ea20f9c': {
        'NOMBRE':'CAYC_ESTANDAR_ES_Y_EN_V2'
      },

      '5ec6b0a6b473cb6d3e9275ff': {
        'NOMBRE':'04_EN_TR_ESTANDAR_PULSECHECK'
      },

      '5f2adf75b473cb6d3eb782e2': {
        'NOMBRE':'REACTIVOS-BRASIL-PT'
      },

      '5f0773b196bd3c7a9e469a8b': {
        'NOMBRE':'TR_ESTANDAR_+COVID'
      },

      '5f0773ea96bd3c7a9e469e56': {
        'NOMBRE':'TR TI + EVP + GPTW LEADER_+COVID'
      },

      '5f07740e96bd3c7a9e46a0f1': {
        'NOMBRE':'TR TI + EVP_+COVID'
      },

      '5f40081eb473cb6d3ec99926': {
        'NOMBRE':'TR TI + EVP + GPTW LEADER TR'
      },

      '5f230cdab473cb6d3e89bd9a': {
        'NOMBRE':'Broker 14-ESTANDAR-ESPAÑOL'
      },
      '5f5fbb3496bd3c7a9eac2768': {
        'NOMBRE':'04_ESP_ING_ESTANDAR_US'
      },

      '5f5fb74496bd3c7a9eab015a': {
        'NOMBRE':'04_ESP_ING_ESTANDAR_MX'
      },

      '5f68c206b473cb6d3ebe8473': {
        'NOMBRE':'04_ESP_ING_ESTANDAR_US'
      },

      '5f68c222b473cb6d3ebe94b3': {
        'NOMBRE':'04_ESP_ING_ESTANDAR_MX'
      },
      '5f84a2fab473cb6d3e017c0d': {
        'NOMBRE':'ESP_ESTANDAR_IDIOMAS'
      },
      '5f733fcab473cb6d3e19d56c': {
        'NOMBRE':'04_ESP_Gobierno_MX'
      },
      // pendiente TK
      '5e14fc2cf323d72aac6d8722': {
        'NOMBRE':' '
      },
      // pendiente TK
      '5e14fcc4f323d72aac6d8723': {
        'NOMBRE':' '
      },
      // pendiente MX
      '5d71b21db11f333a30de813e': {
        'NOMBRE':' '
      },

      '5f99fa14b473cb6d3e2d4012': {
        'NOMBRE':'TR_EN_DE_PT_ZH1_TI_+_EVP'
      },

      '5f9b4550b473cb6d3e51c24d': {
        'NOMBRE':'01_NORM035_ES_EN_-50'
      },

      '5fac18aeb473cb6d3e0d3d91': {
        'NOMBRE': '04_ESP_ING_ESTANDAR_MX'
      },
      '5fac1b3eb473cb6d3e0d6cff': {
        'NOMBRE': '04_ESP_ING_ESTANDAR_US'
      },
      '5fcebf59c1057065a70fe712':{
        'NOMBRE':'TR_ESTANDAR_+COVID v2'
      },
      '6046a10e7308ab51607f95b5':{
        'NOMBRE':''
      }
  }

  export const paises = {
    '1': 'Mexico',
    '2': 'Costa Rica',
    '3': 'Panama'
  }

  export const answer = {
    '1': 'Culturele Go-enquête',
    '2': 'Kiosko',
    '3': 'Kiosk',
    '4': 'Papier',
    '5': 'Does not apply',
  }
